import { EventInputData, EventData, Transport } from '../types';
import { EventSchemas, CustomEvent } from './schemas';
import { Validators } from './validators';
import logger from '../debug';
import customEventSchemas from '../custom-events';

export type EventDataValidator = <TType extends keyof EventSchemas & string>(
  type: TType,
  input: EventInputData<TType>,
) => EventData<TType>;

const initValidateSchema =
  (
    validators: Validators,
    { transport, enrichEvent }: { transport: Transport; enrichEvent: <T>(input: T) => T },
  ): EventDataValidator =>
  (type, input) => {
    const schema = validators.getSchema(type);
    logger.debug(`${type}:raw`, input);

    const parseResult = schema.safeParse(input);

    if (parseResult.success) return parseResult.data;

    const { subjectName, action } = customEventSchemas.subjectMapping[type as CustomEvent] || { subjectName: type };

    transport
      .track(
        'tracker-error',
        enrichEvent({
          type: 'schema-validation-failed',
          event: type,
          entity: subjectName,
          action,
          data: JSON.stringify(input, null, 2),
          error: JSON.stringify(parseResult.error, null, 2),
        }),
      )
      .catch(() => {
        /* ignore */
      });

    throw parseResult.error;
  };

export default initValidateSchema;
